import Yup from 'utils/validation/yup-extensions';
import Box from '@mui/material/Box';
import AppWrappedSelect from 'pages/ApplicationRequest/components/containers/AppWrappedSelect';
import AppWrappedTextbox from 'pages/ApplicationRequest/components/containers/AppWrappedTextbox';

const MAX_OTHER_LENGTH = 500;

const RADIOLOGY_VENDOR_OPTIONS = [
	{ key: '100', value: 'External Provider' },
	{ key: '101', value: 'Foundation' },
	{ key: '102', value: 'Nighthawk' },
	{ key: '103', value: 'Quantum' },
	{ key: '104', value: 'TeleRadiology' },
	{ key: '105', value: 'Vrad' },
	{ key: '106', value: 'Allegheny' },
	{ key: '107', value: 'Susquehanna' },
	{ key: '108', value: 'Penn State Path' },
	{ key: '109', value: 'Potomac' },
	{ key: '110', value: 'Path Assoc CPA' },
	{ key: '111', value: 'Jamestown' },
	{ key: '112', value: 'APS' },
	{ key: '113', value: 'Muse' },
	{ key: '114', value: 'OIP' },
	{ key: '115', value: 'Kidney Care' },
	{ key: '116', value: 'UPP Quantum' },
	{ key: '-1', value: 'Other' },
];

export const FORM_FIELD_KEYS = {
	RADIOLOGY_VENDOR: 'RADIOLOGY_VENDOR',
	RADIOLOGY_OTHER: 'RADIOLOGY_OTHER',
};

export const INITIAL_VALUES = {
	[FORM_FIELD_KEYS.RADIOLOGY_VENDOR]: '',
	[FORM_FIELD_KEYS.RADIOLOGY_OTHER]: '',
};

export const VALIDATION_SCHEMA = {
	[FORM_FIELD_KEYS.RADIOLOGY_VENDOR]: Yup.string().required(
		'Please select a vendor.',
	),
	[FORM_FIELD_KEYS.RADIOLOGY_OTHER]: Yup.string().when(
		FORM_FIELD_KEYS.RADIOLOGY_VENDOR,
		{
			is: 'Other',
			then: schema =>
				schema
					.required('Please specify the vendor.')
					.max(
						MAX_OTHER_LENGTH,
						`You have exceeded the character count (${MAX_OTHER_LENGTH}).`,
					),
			otherwise: schema => schema.notRequired(),
		},
	),
};

/**
 * Radiology vendor supplement form fields.
 * @param {{ formik: import('formik').FormikProps<object> }} props
 */
export const RadiologySupplement = ({ formik }) => {
	const vendorValue = formik.values[FORM_FIELD_KEYS.RADIOLOGY_VENDOR];

	return (
		<Box>
			<AppWrappedSelect
				name={FORM_FIELD_KEYS.RADIOLOGY_VENDOR}
				label='Radiology Vendor'
				formik={formik}
				options={RADIOLOGY_VENDOR_OPTIONS}
				isRequired
			/>
			{vendorValue === 'Other' && (
				<AppWrappedTextbox
					name={FORM_FIELD_KEYS.RADIOLOGY_OTHER}
					label='Other Radiology Provider'
					formik={formik}
					isRequired
					maxLength={MAX_OTHER_LENGTH}
					inputProps={{ maxLength: MAX_OTHER_LENGTH }}
				/>
			)}
		</Box>
	);
};
